var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharingFilled = function SvgSharingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3535 4.25C15.68 3.09575 16.7412 2.25 18 2.25C19.5188 2.25 20.75 3.48122 20.75 5C20.75 6.51878 19.5188 7.75 18 7.75C16.7412 7.75 15.68 6.90425 15.3535 5.75H9.5H7.5C5.98122 5.75 4.75 6.98122 4.75 8.5C4.75 10.0188 5.98122 11.25 7.5 11.25H16.5C18.8472 11.25 20.75 13.1528 20.75 15.5C20.75 17.8472 18.8472 19.75 16.5 19.75H8.64648C8.32002 20.9043 7.25878 21.75 6 21.75C4.48122 21.75 3.25 20.5188 3.25 19C3.25 17.4812 4.48122 16.25 6 16.25C7.25878 16.25 8.32002 17.0957 8.64648 18.25H16.5C18.0188 18.25 19.25 17.0188 19.25 15.5C19.25 13.9812 18.0188 12.75 16.5 12.75H7.5C5.15279 12.75 3.25 10.8472 3.25 8.5C3.25 6.15279 5.15279 4.25 7.5 4.25H9.5H15.3535Z"
  })));
};
export default SvgSharingFilled;